export const TIMEOUT = 60 * 1000
